import styled from "styled-components";
import { StepperThemeType } from "../../types";

type StepContainerProps = {
  disabled: boolean;
};

type StepperStylesProps = {
  complete?: boolean;
  active?: boolean;
  disabled?: boolean;
  styles: StepperThemeType;
};

export const StepContainer = styled.div<StepContainerProps>`
  &:hover {
    cursor: ${(props) => (props.disabled ? "default" : "pointer")};
  }
`;

const StepStyled = styled.div<StepperStylesProps>`
  ${(props) =>
    props.active &&
    `
    &:before {
      content: "";
      position: absolute;
      width: calc((${props.styles.size}) + 9px);
      height: calc((${props.styles.size}) + 9px);
      top: -6.5px;
      left: -6.5px;
      border: 4px solid ${props.styles.activeBorderColor};
    }
  `}
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) =>
    props.disabled
      ? props.styles.disabled.color
      : props.complete
      ? props.styles.complete.color
      : props.styles.incomplete.color};
  background: ${(props) =>
    props.disabled
      ? props.styles.disabled.background
      : props.complete
      ? props.styles.complete.background
      : props.styles.incomplete.background};
  border: 2px solid
    ${(props) =>
      props.disabled
        ? props.styles.disabled.borderColor
        : props.complete
        ? props.styles.complete.borderColor
        : props.styles.incomplete.borderColor};
  width: ${(props) => props.styles.size};
  height: ${(props) => props.styles.size};

  &:hover {
    cursor: ${(props) => (props.disabled ? "default" : "pointer")};
  }
`;

export const Circle = styled(StepStyled)<StepperStylesProps>`
  &:before {
    border-radius: 50%;
  }
  border-radius: 50%;
`;

export const Diamond = styled(StepStyled)<StepperStylesProps>`
  &:before {
    border-radius: 4px;
  }
  transform: rotateX(0deg) rotateZ(45deg);
  border-radius: ${(props) => (props.active ? 0 : "4px")};
`;

export const Base = styled(StepStyled)<StepperStylesProps>`
  &:before {
    border-radius: 4px;
  }
  transform: rotateX(0deg) rotateZ(45deg);
  border-radius: ${(props) => (props.active ? 0 : "4px")};
`;

export const DiamondContent = styled.div<StepperStylesProps>`
  transform: rotateX(-25deg) rotateZ(-45deg);
`;

export const StepSpacerStyled = styled.div<StepperStylesProps>`
  display: block;
  border-color: ${(props) => props.styles.spacerColor};
  border-top-style: solid;
  border-top-width: ${(props) => props.styles.spacerWidth};
  width: 100%;
  margin: 0;
`;

export const StepLabel = styled.span<StepperStylesProps>`
  font-style: italic;
  color: ${(props) =>
    props.disabled
      ? props.styles.disabled.labelColor
      : props.complete
      ? props.styles.complete.labelColor
      : props.styles.incomplete.labelColor};
`;
